export default __webpack_public_path__ + "static/Narcoberry-65e8ec1e603049df2ee065389b6fe684.png";